import React__default from 'react';
import styles from './Divider.scss.mjs';

function Divider({
  height
}) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.Divider,
    style: {
      '--osui_height-divider': height ? `var(--p-space-${height})` : '100%'
    }
  });
}

export { Divider };
